import { ArrowRightIcon } from "lucide-react";
import { DepositForm } from "../DepositForm";

export function EnergizePage() {
  return (
    <DepositForm
      title="Energize the force field"
      subtitle={
        <>
          Deposit <ArrowRightIcon className="inline-block w-4 h-4 -mt-1" />{" "}
          energize the force field{" "}
          <ArrowRightIcon className="inline-block w-4 h-4 -mt-1" /> earn $P
        </>
      }
      description="Permutation Pesos is the labor-backed currency of Permutation City. It is rewarded for contributions to the city in the form of energy or labor. It can be used to acquire a passport and to participate in trade within the city."
      objectId={32793}
    />
  );
}
